import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { CategoryService } from '../../../../../admin/src/app/services/category.service';
import { ProductService } from '../../../../../admin/src/app/services/product.service';
import { Category } from '../../../../../admin/src/app/models/category';
import { Product } from '../../../../../admin/src/app/models/product';
import { environment } from '../../../environments/environment';
import { LanguageService } from '../../services/language.service';

export interface IMenuEntry {
  label: string;
  icon: string;
  link: string;
  external: boolean;
  visible: boolean;
}

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit, OnDestroy {

  kbLink: string = environment.knowledgeBaseUrl;

  categoryId: string;

  category: Category;

  productId: string;

  product: Product;

  menu: IMenuEntry[] = [];

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private categorySvc: CategoryService,
    private productSvc: ProductService,
    private translate: TranslateService,
    public language: LanguageService
  ) { }

  ngOnInit() {
    this.sub = this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('categoryId');
      this.productId = params.get('productId');
      let lang = this.translate.currentLang;
      forkJoin(this.getCategory(), this.getProduct()).subscribe(() => {
        let query = encodeURIComponent(this.product.name).replace(/%20/g, '+');
        this.menu = [
          <IMenuEntry>{ label: 'PRODUCT_MENU_INFORMATION', link: 'information', visible: true },
          <IMenuEntry>{ label: 'PRODUCT_MENU_MANUAL', link: 'manual', visible: !!this.product.manualVisible },
          <IMenuEntry>{ label: 'PRODUCT_MENU_FAQS', link: 'faqs', visible: !!this.product.faqsVisible },
          <IMenuEntry>{ label: 'PRODUCT_MENU_KB', link: 'kb', visible: true },
          <IMenuEntry>{ label: 'PRODUCT_MENU_TECHNICAL_SHEET', link: 'technical-sheet', visible: !!this.product.technicalSheetsVisible },
          <IMenuEntry>{ label: 'PRODUCT_MENU_MEDIA', link: 'media', visible: !!this.product.mediaVisible },
          <IMenuEntry>{ label: 'PRODUCT_MENU_VIDEO', link: 'videos', visible: !!this.product.videosVisible },
          <IMenuEntry>{ label: 'PRODUCT_MENU_SOFTWARES', link: 'softwares', visible: !!this.product.softwaresVisible }
        ];
      });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCategory() {
    return new Observable(observer => {
      if (!!this.categoryId) {
        this.categorySvc.get(this.categoryId).subscribe(data => {
          this.category = Object.assign({}, data.payload);
          observer.next();
          observer.complete();
        });
      } else {
        observer.next();
        observer.complete();
      }
    });
  }

  getProduct() {
    return new Observable(observer => {
      this.productSvc.get(this.productId).subscribe(data => {
        this.product = Object.assign({}, data.payload);
        observer.next();
        observer.complete();
      });
    });
  }

}
